export const sendAnalyticsEvent = (
    eventName: string,
    params?: Record<string, unknown>
) => {
    try {
        if (!window.gtag) {
            return;
        }

        window.gtag("event", eventName, params);
    }
    catch {
        console.error("Failed to send analytics event: ", eventName, params);
    }

};